import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Mail, Phone, X } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const SupportButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="support-button-container">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            className="absolute bottom-16 right-0 bg-white rounded-xl shadow-2xl border border-slate-200 p-4 w-72"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-bold text-[#1A4D7F]">{t.support.needHelp}</h3>
              <button 
                onClick={() => setIsOpen(false)}
                className="p-1 hover:bg-slate-100 rounded-full transition-colors"
              >
                <X className="w-4 h-4 text-slate-500" />
              </button>
            </div>
            
            <p className="text-sm text-slate-600 mb-4">
              {t.support.description}
            </p>
            
            <div className="space-y-3">
              <a
                href="mailto:customer-support@aonevisas.com"
                className="flex items-center gap-3 p-3 bg-[#1A4D7F] text-white rounded-lg hover:bg-[#153e66] transition-colors"
                data-testid="support-email-link"
              >
                <Mail className="w-5 h-5" />
                <div>
                  <p className="font-medium text-sm">{t.support.emailSupport}</p>
                  <p className="text-xs opacity-80">customer-support@aonevisas.com</p>
                </div>
              </a>
              
              <a
                href="tel:+971503312723"
                className="flex items-center gap-3 p-3 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-colors"
                data-testid="support-phone-link"
              >
                <Phone className="w-5 h-5" />
                <div>
                  <p className="font-medium text-sm">{t.support.callUs}</p>
                  <p className="text-xs text-slate-500">+971 50 331 2723</p>
                </div>
              </a>
            </div>
            
            <div className="mt-4 pt-4 border-t border-slate-100">
              <p className="text-xs text-slate-500 text-center">
                {t.support.available}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-colors ${
          isOpen ? 'bg-slate-700' : 'bg-[#009FB7] hover:bg-[#008fa5]'
        }`}
        data-testid="support-toggle-button"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </motion.button>
    </div>
  );
};

export default SupportButton;
